// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"09a52a8bd1cebfea5ac6","655":"5f35c46c8d31ad99a411"}[chunkId] + ".js";
};